(() => {
  if (window.fhReviewDragReady) return;
  window.fhReviewDragReady = true;

  const tracks = 'fh-product-reviews [data-track], fh-customer-reviews .fh-customer-reviews__track';
  let gesture = null;
  let blockedClick = null;

  function finish() {
    if (!gesture) return;
    const { track, pointerId, dragging } = gesture;
    gesture = null;
    if (dragging) blockedClick = { track, expires: performance.now() + 400 };
    track.removeAttribute('data-fh-dragging');
    if (track.hasPointerCapture?.(pointerId)) track.releasePointerCapture(pointerId);
  }

  function start(event) {
    finish();
    blockedClick = null;
    if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary) return;
    if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
    const track = event.target.closest?.(tracks);
    if (!track || track.scrollWidth <= track.clientWidth + 1) return;
    gesture = {
      track, pointerId: event.pointerId, x: event.clientX, y: event.clientY,
      left: track.scrollLeft, dragging: false
    };
  }

  function move(event) {
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    if (!(event.buttons & 1) || !gesture.track.isConnected) return finish();
    const delta = event.clientX - gesture.x;
    if (!gesture.dragging) {
      if (Math.abs(event.clientY - gesture.y) > Math.max(6, Math.abs(delta))) return finish();
      if (Math.abs(delta) < 6) return;
      gesture.dragging = true;
      gesture.track.setAttribute('data-fh-dragging', '');
      gesture.track.setPointerCapture?.(event.pointerId);
    }
    event.preventDefault();
    gesture.track.scrollLeft = gesture.left - delta;
  }

  function stop(event) {
    if (event.pointerId === gesture?.pointerId) finish();
  }

  function preventDragClick(event) {
    // Pointer capture can retarget the release click to the rail itself.
    if (!blockedClick || event.detail === 0 || performance.now() > blockedClick.expires) return;
    if (!blockedClick.track.contains(event.target)) return;
    blockedClick = null;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function preventNativeDrag(event) {
    if (gesture?.track.contains(event.target)) event.preventDefault();
  }

  // Delegation also covers deferred cards and Shopify theme-editor replacements.
  document.addEventListener('pointerdown', start, true);
  document.addEventListener('pointermove', move, { capture: true, passive: false });
  ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => {
    document.addEventListener(type, stop, true);
  });
  document.addEventListener('click', preventDragClick, true);
  document.addEventListener('dragstart', preventNativeDrag, true);
  document.addEventListener('selectstart', preventNativeDrag, true);
  window.addEventListener('blur', finish);
})();
